// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AEXzM","tabsBox":"styles_tabsBox__32_u8","createButton":"styles_createButton__10ntr"};